import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=07660dff&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
import style1 from "./Groups.vue?vue&type=style&index=1&id=07660dff&prod&scoped=true&lang=css"
import style2 from "./Groups.vue?vue&type=style&index=2&id=07660dff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07660dff",
  null
  
)

export default component.exports